import { useState } from 'react'
import { IFilteredMeetingRoomList } from 'types/MeetingRoomType'

export default function useMeetingRoomResModal() {
  const [modal, setModal] = useState(false)
  const [notification, setNotification] = useState(false)
  const [selectedRoom, setSelectedRoom] = useState<IFilteredMeetingRoomList>()

  const closeModal = () => setModal(false)
  const openModal = (room?: IFilteredMeetingRoomList) => {
    setModal(true)
    if (room) setSelectedRoom(room)
  }

  return { selectedRoom, setSelectedRoom, modal, openModal, closeModal, notification, setNotification }
}
